import { forwardRef } from 'react';

export const SaleHorizon4Icon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        width="110"
        height="110"
        viewBox="0 0 110 110"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M94.4 33.3H15.5V97h78.9V33.3Z"
          stroke="currentColor"
          fill="none"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M94.4 19.1H15.5v14.2h78.9V19.1Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3 29.9c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5Zm61.1 0c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5Z"
          fill="#fff"
        />
        <path
          d="M85.5 13.5v12.9M24.3 13.5v12.9"
          stroke="currentColor"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35 70.68v-2.917l7.108-11.524h2.444v4.039h-1.446l-4.481 7.297v.137h10.1v2.968H35Zm8.172 3.08v-3.97l.067-1.291v-12.26h3.375V73.76h-3.442Zm15.941-10.206v2.892h-7.765v-2.892h7.765ZM68.632 74a7.5 7.5 0 0 1-2.536-.454 5.758 5.758 0 0 1-2.178-1.445c-.643-.668-1.153-1.552-1.53-2.652-.37-1.101-.556-2.453-.556-4.055.005-1.472.169-2.787.49-3.944.327-1.164.793-2.15 1.397-2.96.61-.81 1.338-1.426 2.186-1.848.848-.428 1.799-.642 2.852-.642 1.136 0 2.139.228 3.01.684a5.589 5.589 0 0 1 2.094 1.84 5.69 5.69 0 0 1 .964 2.61h-3.55c-.138-.611-.429-1.09-.872-1.438-.444-.348-.992-.522-1.646-.522-1.109 0-1.951.496-2.528 1.489-.57.992-.861 2.34-.873 4.046h.117a4.055 4.055 0 0 1 1.03-1.326 4.7 4.7 0 0 1 1.489-.847c.56-.2 1.15-.3 1.77-.3 1.01 0 1.907.246 2.694.736a5.156 5.156 0 0 1 1.862 2.002c.455.85.682 1.822.682 2.918 0 1.186-.269 2.241-.806 3.165a5.662 5.662 0 0 1-2.237 2.173c-.953.519-2.061.776-3.325.77Zm-.017-2.909c.555 0 1.05-.137 1.488-.41a2.889 2.889 0 0 0 1.031-1.113c.25-.467.374-.992.374-1.574 0-.582-.124-1.103-.374-1.565a2.865 2.865 0 0 0-1.014-1.104 2.707 2.707 0 0 0-1.48-.41c-.415 0-.8.08-1.155.239a2.9 2.9 0 0 0-.923.667 3.22 3.22 0 0 0-.615.993c-.15.37-.225.767-.225 1.189 0 .564.125 1.08.374 1.548a3.05 3.05 0 0 0 1.031 1.121c.438.28.934.42 1.488.42Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
